<template>
  <div>
    <timgname :params='params' :tabfrom='tabfrom'></timgname>
    <!-- <div class='model_div'>
      <div>{{tabfrom.title}}</div>
      <a-icon type="appstore" theme="filled" style='font-size: 1.2rem;' @click='ismodeltab = true'/></div>
      <modeltab @child='ismodeltab = false' :tabfrom='tabfrom' :ismodeltab='ismodeltab'></modeltab> -->
  </div>
</template>

<script>
  import modeltab from '@/components/modeltab/modeltabs'

  export default{
    components:{modeltab},
    props:['isnum','params'],
    data(){
      return{
        newlist:[this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh,this.$lang.wskh],
        tabfrom:{
          typename:this.$lang.klzh,
          title: '',
          taname: '',
          list: [this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh],
          // list: [this.$lang.qlkh,this.$lang.ydkh,this.$lang.yykh,this.$lang.zxkh,this.$lang.wskh],
          urllist:['/apply_in_person_individual','/sent_by_post_individual','/account_opening_appointment','/account_opening_online'
          ,'https://hk.qmisit.com/accopen/?lang='],
        },
        ismodeltab:false,
        onlinestate:sessionStorage['onlinestate']
      }
    },
    mounted(){
      this.tabfrom.taname = this.newlist[this.isnum]
      this.tabfrom.title = this.$lang.klzh + ' • ' + this.tabfrom.taname;
      if(this.onlinestate == 'ipad'){
        this.tabfrom.urllist[4] = 'https://hk.iqmis.com/app/apk/appdownload/khappcn.html?lang='
      }
      console.log(this.tabfrom)
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/assetmanage/newtitle.vue